export default "__VITE_ASSET__DxWtkIUL__"